var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpDownArrows(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "18px",
    viewBox: "0 0 21 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 48") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-48",
    transform: "translate(1.000000, 1.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    stroke: "#FFFFFF",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.3179366,14.5584087 L3.3179366,1.26972016 C3.3179366,1.03729484 3.50153328,0.84887689 3.72801125,0.84887689 C3.95448923,0.84887689 4.1380859,1.03729484 4.1380859,1.26972016 L4.1380859,14.5584087 L6.70966089,11.9096661 C6.87179192,11.7600981 7.11961491,11.7668632 7.27376884,11.9250653 C7.42792276,12.0832673 7.43451478,12.3375982 7.28877394,12.5039868 L4.00191607,15.8771581 C3.84186622,16.0409473 3.58285288,16.0409473 3.42280302,15.8771581 L0.135945155,12.5039868 C0.0231166248,12.399901 -0.0244965493,12.2403903 0.0121655297,12.0893079 C0.0488276087,11.9382255 0.163773753,11.8202609 0.310990192,11.782636 C0.45820663,11.7450112 0.613635771,11.7938747 0.715058208,11.9096661 L3.3179366,14.5584087 Z",
    id: "Path_1076-path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.86974,1.44319754 L12.2903391,4.09033386 C12.1282081,4.23990188 11.8803851,4.23313675 11.7262312,4.07493472 C11.5720772,3.91673269 11.5654852,3.66240183 11.7112261,3.49601321 L14.9980839,0.122841929 C15.1581338,-0.0409473098 15.4171471,-0.0409473098 15.577197,0.122841929 L18.8640548,3.49601321 C18.9768834,3.60009901 19.0244965,3.75960975 18.9878345,3.91069211 C18.9511724,4.06177448 18.8362262,4.17973913 18.6890098,4.21736396 C18.5417934,4.25498879 18.3863642,4.20612529 18.2849418,4.09033386 L15.6898892,1.44319754 L15.6898892,14.7318861 C15.6898892,14.9643114 15.5062926,15.1527293 15.2798146,15.1527293 C15.0533366,15.1527293 14.86974,14.9643114 14.86974,14.7318861 L14.86974,1.44319754 Z",
    id: "Path_1076-path"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpDownArrows);
export default __webpack_public_path__ + "static/media/up-down-arrows.e9d8633a28acfa264509eb11d409fd6a.svg";
export { ForwardRef as ReactComponent };